function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M64.567 22.116v20.405l7.13 4.49c.188.054.596.058.784 0l30.688-20.69c0-2.45-2.284-4.205-3.573-4.205h-35.03z",
  fill: "#0072c6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M64.567 50.133l6.507 4.47c.917.674 2.022 0 2.022 0-1.101.674 30.077-20.036 30.077-20.036V72.07c0 4.083-2.613 5.795-5.551 5.795h-33.06v-27.73z",
  fill: "#0072c6"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "#0072c6"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30.873 40.726c-2.218 0-3.985 1.042-5.29 3.123-1.304 2.08-1.958 4.834-1.958 8.263 0 3.479.654 6.229 1.959 8.25 1.304 2.026 3.016 3.033 5.132 3.033 2.182 0 3.914-.983 5.191-2.95 1.278-1.967 1.92-4.698 1.92-8.188 0-3.64-.619-6.473-1.861-8.498-1.242-2.022-2.938-3.033-5.093-3.033z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 11.754V91.58l60.727 12.733V0L0 11.754zm40.636 53.408c-2.566 3.377-5.912 5.07-10.041 5.07-4.024 0-7.3-1.638-9.834-4.91-2.531-3.275-3.8-7.537-3.8-12.795 0-5.552 1.285-10.042 3.859-13.47 2.574-3.428 5.982-5.144 10.225-5.144 4.008 0 7.252 1.638 9.724 4.92 2.476 3.284 3.715 7.61 3.715 12.98.003 5.521-1.282 9.972-3.848 13.349z"
}));

var SvgOutlook = function SvgOutlook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: 103.17322,
    height: 104.31332,
    viewBox: "0 0 103.17322 104.31332",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOutlook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/outlook.e59faa2f.svg";
export { ForwardRef as ReactComponent };